import React from 'react';
import styled, { keyframes } from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import PropTypes from 'prop-types';

export const TooltipStyle = styled.div`
  background-color: #fff;
  border-radius: 1px;
  box-shadow: 0 0 4px 0 rgba(41, 53, 71, 0.26);
  color: ${Colors.grayscaleCoolGray08};
  flex-direction: column;
  font-size: 9px;
  height: 26px;
  justify-content: center;
  letter-spacing: 0.8px;
  margin-right: ${(props) =>
    props.arrowDirection === 'right'
      ? '20px'
      : '0'}; //change these depending on side tooltip is on
  margin-bottom: ${(props) => (props.arrowDirection === 'down' ? '20px' : '0')};
  opacity: ${(props) => (props.isVisible ? '1' : '0')};
  position: ${(props) =>
    props.isAbsolutePositioned ? 'absolute' : 'relative'};
  text-align: center;
  text-transform: uppercase;
  width: ${(props) => (props.tooltipWidth ? props.tooltipWidth : '80px')};
  display: flex;
`;

export const FadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`;

const TriangleRight = styled.div`
  position: absolute;
  color: #fff;
  text-shadow: 2px 0px 2px rgba(41, 53, 71, 0.26);
  right: -8px;
  outline: none;
  font-family: 'Segoe UI Symbol';
  top: 8px;
`;

const TriangleDown = styled.div`
  position: absolute;
  color: #fff;
  text-shadow: 2px 0px 2px rgba(41, 53, 71, 0.26);
  left: 44%;
  bottom: -8px;
  outline: none;
  font-family: 'Segoe UI Symbol';
  transform: rotate(90deg);
`;

const Tooltip = ({
  tooltipText,
  arrowDirection,
  isVisible,
  tooltipWidth,
  isAbsolutePositioned,
  ...props
}) => {
  return (
    <TooltipStyle
      className="tooltip"
      arrowDirection={arrowDirection}
      tooltipWidth={tooltipWidth}
      isVisible={isVisible}
      isAbsolutePositioned={isAbsolutePositioned}
      {...props}
    >
      <span>{tooltipText ? tooltipText : 'More Info'}</span>
      {arrowDirection === 'down' ? (
        <TriangleDown>▶</TriangleDown>
      ) : (
        <TriangleRight>▶</TriangleRight>
      )}
    </TooltipStyle>
  );
};

Tooltip.propTypes = {
  arrowDirection: PropTypes.string,
  isAbsolutePositioned: PropTypes.any,
  isVisible: PropTypes.any,
  tooltipText: PropTypes.any,
  tooltipWidth: PropTypes.any,
};

export default Tooltip;
